export const ObjToParam = data => {
  return Object.keys(data)
    .map(i => i + '=' + encodeURIComponent(data[i]))
    .join('&');
};

export const MapResponse = (response, getHeader = false) => {
  if (getHeader) {
    return {
      data: response.data,
      statusCode: response.status,
      headers: response.headers
    };
  }
  return { data: response.data, statusCode: response.status };
};



// WEBPACK FOOTER //
// ./src/helper/helper-api.js